// Iniciales para avatares (1 letra si es nombre simple, 2 letras si es compuesto).
export const iniciales = (nombre) => {
  if (!nombre) return '?';
  const parts = nombre.trim().split(/\s+/);
  if (parts.length === 1) return parts[0][0]?.toUpperCase() || '?';
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// "recién" / "hace 5 min" / "hace 2h" / "hace 3d" / "hace 2sem" / "5 may"
export const tiempoRelativo = (iso) => {
  if (!iso) return '';
  const date = new Date(iso);
  const diff = Date.now() - date.getTime();
  const min = Math.floor(diff / 60000);
  if (min < 1) return 'recién';
  if (min < 60) return `hace ${min} min`;
  const h = Math.floor(min / 60);
  if (h < 24) return `hace ${h}h`;
  const d = Math.floor(h / 24);
  if (d < 7) return `hace ${d}d`;
  const w = Math.floor(d / 7);
  if (w < 4) return `hace ${w}sem`;
  return date.toLocaleDateString('es-VE', { day: 'numeric', month: 'short' });
};

// ---- Calendario / grilla mensual ----

export const DOW_LABELS = ['Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb', 'Dom'];
export const MONTH_LABELS = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

export const dateKey = (d) =>
  `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

// Devuelve 42 celdas (6 semanas) empezando el lunes anterior al día 1.
// El consumidor puede usar solo `cells` o también `first` / `last` para etiquetas.
export const buildMonthGrid = (year, month) => {
  const first = new Date(year, month, 1);
  const last = new Date(year, month + 1, 0);
  const dow = (first.getDay() + 6) % 7;
  const start = new Date(first);
  start.setDate(first.getDate() - dow);
  const todayKey = dateKey(new Date());
  const cells = [];
  for (let i = 0; i < 42; i++) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    cells.push({
      date: d,
      inMonth: d.getMonth() === month,
      isToday: dateKey(d) === todayKey,
    });
  }
  return { cells, first, last };
};

// Resuelve el grupo de fecha de una tarea (clave: vencidas | hoy | semana | proximas | sin).
export const groupKeyForFecha = (fecha) => {
  if (!fecha) return 'sin';
  const today = new Date(); today.setHours(0, 0, 0, 0);
  const d = new Date(fecha + 'T00:00:00');
  const diff = Math.floor((d - today) / 86400000);
  if (diff < 0) return 'vencidas';
  if (diff === 0) return 'hoy';
  if (diff <= 7) return 'semana';
  return 'proximas';
};

// Estilos base (bg / txt / dot) para una pill de tarea según su estado y vencimiento.
// `bg` y `txt` van en la pill; `dot` queda disponible cuando se quiere reflejar el estado.
// Vencida sobrescribe todo a rose, excepto si la tarea ya está hecha o cancelada.
export const stylesForTarea = (tarea) => {
  const cat = tarea.estado?.categoria || 'por_hacer';
  let bg = 'bg-slate-100/80';
  let txt = 'text-slate-700';
  let dot = 'bg-slate-400';

  if (cat === 'en_curso') {
    bg = 'bg-cyan-100'; txt = 'text-cyan-900'; dot = 'bg-cyan-500';
  } else if (cat === 'hecho') {
    bg = 'bg-green-100'; txt = 'text-green-800 line-through opacity-70'; dot = 'bg-green-600';
  } else if (cat === 'cancelado') {
    bg = 'bg-slate-100'; txt = 'text-slate-500 line-through opacity-70'; dot = 'bg-slate-400';
  } else if (cat === 'por_hacer') {
    bg = 'bg-slate-200/80'; txt = 'text-slate-800'; dot = 'bg-slate-500';
  }

  const today = new Date(); today.setHours(0, 0, 0, 0);
  const d = tarea.fecha_vencimiento ? new Date(tarea.fecha_vencimiento + 'T00:00:00') : null;
  const vencida = d && d < today && !['hecho', 'cancelado'].includes(cat);
  if (vencida) {
    bg = 'bg-rose-100'; txt = 'text-rose-800'; dot = 'bg-rose-500';
  }

  return { bg, txt, dot };
};

// ----- Referencia de tarea en la URL del slide-over -----
// Dentro de un proyecto la tarea se identifica por su numero (CIMA-3 →
// /tareas/3). En la vista general conviven varios proyectos y los numeros se
// repiten, asi que ahi la referencia es el id de la tarea.

export const refTareaUrl = (tarea, esVistaGeneral) => (
  esVistaGeneral ? tarea?.id : tarea?.numero
);

export const tareaPorRefUrl = (tareas, ref, esVistaGeneral) => (
  (tareas || []).find((t) => (esVistaGeneral ? t.id === ref : t.numero === ref))
);
